const tenant_id = "9107b728-2166-4e5d-8d13-d1ffdf0351ef";
// LOCAL CONFIGS
export const localAppConfig = {
  sf_execution_url: "https://api.one.vocdev.toyota.com/uiRequest/api/uigetStepExecutions",
  sf_execution_steps_url: "https://api.one.vocdev.toyota.com/uiRequest/api/uigetStepFunctionSteps",
  sf_execution_steps_req_url: "https://api.one.vocdev.toyota.com/uiRequest/api/uigetRequestData",
  sf_execution_steps_res_url: "https://api.one.vocdev.toyota.com/uiRequest/api/uigetResponseData",
  redirect_url: "http://localhost:3000",
  auth_token_gen_url: "",
  auth_token: "",
  client_id: "a323d493-71b3-435e-b5f7-2d21f16383ee",
  tenant_id: tenant_id,
};

// DEV CONFIGS
export const devAppConfig = {
  sf_execution_url: "https://api.one.vocdev.toyota.com/uiRequest/api/uigetStepExecutions",
  sf_execution_steps_url: "https://api.one.vocdev.toyota.com/uiRequest/api/uigetStepFunctionSteps",
  sf_execution_steps_req_url: "https://api.one.vocdev.toyota.com/uiRequest/api/uigetRequestData",
  sf_execution_steps_res_url: "https://api.one.vocdev.toyota.com/uiRequest/api/uigetResponseData",
  redirect_url: "https://one.vocdev.toyota.com",
  auth_token_gen_url: "",
  auth_token: " ",
  client_id: "a323d493-71b3-435e-b5f7-2d21f16383ee",
  tenant_id: tenant_id,
};

// QA CONFIGS
export const qaAppConfig = {
  sf_execution_url: "https://api.one.vocqa.toyota.com/uiRequest/api/uigetStepExecutions",
  sf_execution_steps_url: "https://api.one.vocqa.toyota.com/uiRequest/api/uigetStepFunctionSteps",
  sf_execution_steps_req_url: "https://api.one.vocqa.toyota.com/uiRequest/api/uigetRequestData",
  sf_execution_steps_res_url: "https://api.one.vocqa.toyota.com/uiRequest/api/uigetResponseData",
  redirect_url: "https://one.vocqa.toyota.com",
  auth_token_gen_url: "",
  auth_token: "",
  client_id: "f1304b94-aa77-4bb1-aec2-0c20895f4cfe",
  tenant_id: tenant_id,
};

// UAT CONFIGS
export const uatAppConfig = {
  sf_execution_url: "https://api.one.vocuat.toyota.com/uiRequest/api/uigetStepExecutions",
  sf_execution_steps_url: "https://api.one.vocuat.toyota.com/uiRequest/api/uigetStepFunctionSteps",
  sf_execution_steps_req_url: "https://api.one.vocuat.toyota.com/uiRequest/api/uigetRequestData",
  sf_execution_steps_res_url: "https://api.one.vocuat.toyota.com/uiRequest/api/uigetResponseData",
  redirect_url: "https://one.vocuat.toyota.com/",
  auth_token_gen_url: "",
  auth_token: "",
  client_id: "",
  tenant_id: tenant_id,
};
export const prodAppConfig = {
  sf_execution_url: "https://api.one.voc.toyota.com/uiRequest/api/uigetStepExecutions",
  sf_execution_steps_url: "https://api.one.voc.toyota.com/uiRequest/api/uigetStepFunctionSteps",
  sf_execution_steps_req_url: "https://api.one.voc.toyota.com/uiRequest/api/uigetRequestData",
  sf_execution_steps_res_url: "https://api.one.voc.toyota.com/uiRequest/api/uigetResponseData",
  redirect_url: "https://one.voc.toyota.com/",
  auth_token_gen_url: "",
  auth_token: "",
  client_id: "0c786950-6b41-4ca2-8169-092d96f271ce",
  tenant_id: "8c642d1d-d709-47b0-ab10-080af10798fb",
};
/**local,dev,qa,uat */
const flag: string = "prod";
let appConfig: {
  sf_execution_url: string;
  sf_execution_steps_url: string;
  sf_execution_steps_req_url: string;
  sf_execution_steps_res_url: string;
  redirect_url: string;
  auth_token_gen_url: string;
  auth_token: string;
  client_id: string;
  tenant_id: string;
};
if (flag === "local") {
  appConfig = localAppConfig;
}
if (flag === "dev") {
  appConfig = devAppConfig;
}
if (flag === "qa") {
  appConfig = qaAppConfig;
}
if (flag === "uat") {
  appConfig = uatAppConfig;
}
if (flag === "prod") {
  appConfig = prodAppConfig;
}

export { appConfig };
